import React from 'react';
import { ChevronLeftIcon } from 'lucide-react';
export const NameConfirmation = ({
  userData,
  onUserDataChange,
  onBack,
  onNext
}) => {
  return <div className="flex flex-col p-6 flex-grow" data-id="element-371">
      <div className="flex items-center mb-6" data-id="element-372">
        <button onClick={onBack} className="mr-4" data-id="element-373">
          <ChevronLeftIcon size={24} data-id="element-374" />
        </button>
        <div className="flex-grow flex space-x-2" data-id="element-375">
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-376"></div>
          <div className="h-1 bg-[#5c5cf5] flex-grow rounded-full" data-id="element-377"></div>
          <div className="h-1 bg-gray-200 flex-grow rounded-full" data-id="element-378"></div>
          <div className="h-1 bg-gray-200 flex-grow rounded-full" data-id="element-379"></div>
          <div className="h-1 bg-gray-200 flex-grow rounded-full" data-id="element-380"></div>
        </div>
      </div>
      <h1 className="text-2xl font-bold mb-2" data-id="element-381">Confirm your name</h1>
      <p className="text-gray-700 mb-6" data-id="element-382">
        Please validate your name is correct that we pulled from your ID.
      </p>
      <div className="mb-4" data-id="element-383">
        <label className="block text-gray-700 mb-2" data-id="element-384">First Name</label>
        <input type="text" value={userData.firstName} onChange={e => onUserDataChange('firstName', e.target.value)} className="w-full p-3 border border-gray-300 rounded-lg" data-id="element-385" />
      </div>
      <div className="mb-4" data-id="element-386">
        <label className="block text-gray-700 mb-2" data-id="element-387">Last Name</label>
        <input type="text" value={userData.lastName} onChange={e => onUserDataChange('lastName', e.target.value)} className="w-full p-3 border border-gray-300 rounded-lg" data-id="element-388" />
      </div>
      <div className="mt-auto" data-id="element-389">
        <button className="w-full bg-[#5c5cf5] text-white py-3 rounded-full font-medium" onClick={onNext} data-id="element-390">
          Next
        </button>
      </div>
    </div>;
};